var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgCopyIcon = function (props) { return (_jsx("svg", __assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M13.75.833h-10c-.917 0-1.667.75-1.667 1.667v11.667H3.75V2.5h10V.833Zm2.5 3.334H7.083c-.916 0-1.666.75-1.666 1.666V17.5c0 .917.75 1.667 1.666 1.667h9.167c.917 0 1.667-.75 1.667-1.667V5.833c0-.916-.75-1.666-1.667-1.666Zm0 13.333H7.083V5.833h9.167V17.5Z", fill: "#757575" }) }))); };
var Memo = memo(SvgCopyIcon);
export default Memo;
//# sourceMappingURL=CopyIcon.js.map